// Canonical password policy (PRD 21 §5.2 / §6): 8~64 chars, must combine
// letters + numbers + special characters. The spec mandates DUAL enforcement —
// frontend `maxlength=64` on the input AND validation here (+ server). This is the
// single source of truth; every password field (login, signup, reset, my-profile)
// must validate through these helpers rather than re-deriving the rule.

export const PASSWORD_MIN = 8;
export const PASSWORD_MAX = 64;

export type PasswordViolation =
  | 'tooShort'
  | 'tooLong'
  | 'missingLetter'
  | 'missingNumber'
  | 'missingSymbol';

// Returns the first policy violation, or null when the password is valid.
// Order matters — length is checked before composition so the message is specific.
export function checkPassword(password: string): PasswordViolation | null {
  if (password.length < PASSWORD_MIN) return 'tooShort';
  if (password.length > PASSWORD_MAX) return 'tooLong';
  if (!/[A-Za-z]/.test(password)) return 'missingLetter';
  if (!/\d/.test(password)) return 'missingNumber';
  if (!/[^A-Za-z0-9]/.test(password)) return 'missingSymbol';
  return null;
}

export function isValidPassword(password: string): boolean {
  return checkPassword(password) === null;
}
